window.Swivel = {
    features: {
        SECURE_PRIVACY:[1,2,3,4,5,6,7,8,9,10]
    },
    getBucket: function() {
        const swivelBucketKey = 'Swivel_Bucket'
        let swivelBucket = JSON.parse(localStorage.getItem(swivelBucketKey))
        if (!Number.isInteger(swivelBucket)) {
            swivelBucket = Math.floor(Math.random() * (9 - 1 + 1)) + 1
            localStorage.setItem(swivelBucketKey, swivelBucket)
        }
        return swivelBucket
    },
    featureEnabled: function(feature) {
        return this.features[feature].includes(this.getBucket())
    }
}

// Trigger it once to make sure we always have one
Swivel.getBucket()